import { faArrowCircleDown, faArrowCircleUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useMemo, useState } from 'react'
import { useMobileRecordContext } from "../../../contexts/mobileRecordContext"
import { sortFields } from "../../../utilities/mobileRecordHelper"
import { pluck } from "../../../utilities/utils"
import ChildRecord from "./childRecord"
import ChildRecords from "./childRecords"

const GroupedChildRecords = ({ map, recordType, records }) => {
  const { formTemplates } = useMobileRecordContext()
  const [showRecords, setShowRecords] = useState(false)

  const recordTypeLabel = useMemo(() => recordType?.replaceAll('_', ' '), [recordType])
  const formTemplate = useMemo(() => formTemplates[recordType], [recordType, formTemplates])
  const sortedFormFields = useMemo(() => sortFields(formTemplate), [formTemplate])
  const tableHeaders = useMemo(() => pluck(sortedFormFields, 'label'), [formTemplate])

  return (
    <div className='flex-col bg-gray-200 flex w-full pb-2'>
      <div className='items-center flex hover:bg-gray-200 p-2 cursor-pointer gap-x-2 w-full'
        onClick={() => setShowRecords(!showRecords)}>
        <FontAwesomeIcon icon={showRecords ? faArrowCircleUp : faArrowCircleDown} size='lg' />
        <h2 className='w-8 uppercase whitespace-nowrap leading-none'>
          {recordTypeLabel}
        </h2>
      </div>
      {showRecords &&
        <div className="overflow-x-auto w-full p-2">
        <table className="table-auto border-collapse border border-gray-300" key={recordType}>
          <tbody>
            {records.map((record, index) => (
              <ChildRecord
                key={record.id}
                map={map}
                childRecord={record}
                sortedFormFields={sortedFormFields}
                tableHeaders={tableHeaders}
                showHeaders={index === 0}
              />
            ))}
          </tbody>
        </table>
        {records.map(record => (
          <ChildRecords key={[...map, record.uuid].join('-')} map={[record.uuid]} />
        ))}
      </div>
      }
    </div>
  )
}

export default GroupedChildRecords
